import { Dispatch }                from "redux";
import FetchStatusRepository       from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import ErrorRepository             from "../../../../domain/fundamentals/message/error/ErrorRepository";
import { finishFetch, startFetch } from "../../../redux/common/fetch/FetchStatusAction";
import ErrorDataSource             from "../../error/ErrorDataSource";

class FetchStatusDataSource implements FetchStatusRepository {
  readonly dispatch: Dispatch;

  constructor(dispatch: Dispatch, private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch)) {
    this.dispatch = dispatch;
  }

  finish(): void {
    this.dispatch(finishFetch());
  }

  start(): void {
    this.errorRepository.init();
    this.dispatch(startFetch());
  }

}

export default FetchStatusDataSource;
